import React, {Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as cashAction from "../store/cashhistory";
import * as apiUtil from "../../../util/apiUtil";
import * as stringUtil from '../../../util/stringUtil';

import YearMonthComp from "../component/YearMonthComp";
import PaginationComponent from "../../../component/table/Pagination";
import RefundSuccessModal from "../component/modal/RefundSuccessModal";
import RefundFailModal from "../component/modal/RefundFailModal";
import PaymentUsageModal from '../component/modal/PaymentUsageModal';
import Loading from "../../../component/loading/Loading";
import AccountInfoUploadModal from "../component/modal/AccountInfoUploadModal";
import PackagePaymentUsageModal from "../component/modal/PackagePaymentUsageModal";

const paymethodMap = {
    'All': '전체',
    'Card': '신용카드',
    'VBank': '무통장 입금',
    'DirectBank': '실시간 계좌 이체'
}

class CashChargedHistoryComp extends Component {

    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.setValue = this.setValue.bind(this);

        /* 충전내역 상단 검색 조건 */
        this.handleYearFromSelect = this.handleYearFromSelect.bind(this);
        this.handleMonthFromSelect = this.handleMonthFromSelect.bind(this);
        this.handleYearToSelect = this.handleYearToSelect.bind(this);
        this.handleMonthToSelect = this.handleMonthToSelect.bind(this);

        this.onChangeCharged = this.onChangeCharged.bind(this);

        /* 모달 OPEN, CLOSE 관련 */
        this.handlePaymentUsageModal = this.handlePaymentUsageModal.bind(this);
        this.handleAccountInfoUploadModal = this.handleAccountInfoUploadModal.bind(this);
        this.handlePackagePaymentUsageModal = this.handlePackagePaymentUsageModal.bind(this);
        this.handleSuccessModal = this.handleSuccessModal.bind(this);
        this.handleFailModal = this.handleFailModal.bind(this);

        /* WAS API 요청 관련 */
        this.ajaxGetPaymentList = this.ajaxGetPaymentList.bind(this);
        this.ajaxDownloadExcel = this.ajaxDownloadExcel.bind(this);
        this.ajaxGetPaymentUsage  = this.ajaxGetPaymentUsage.bind(this);

        /* 기타 메서드 */
        this.handleSearch = this.handleSearch.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSingleCheck = this.handleSingleCheck.bind(this);
        this.handleAllCheck = this.handleAllCheck.bind(this);

        this.state = {
            loading: false,
            thisYearFrom: new Date().getFullYear(),
            thisMonthFrom: new Date().getMonth(),
            thisYearTo: new Date().getFullYear(),
            thisMonthTo: new Date().getMonth() + 1,
            success: false,
            fail:false,
            usage: false,
            packageModal: false,
            usageList: [],
            paymentInfo: false,
            account: false,
            checkItems: [],
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.props.page !== nextProps.page
            || this.props.size !== nextProps.size
            || this.props.total !== nextProps.total
            || this.props.yearFrom !== nextProps.yearFrom
            || this.props.monthFrom !== nextProps.monthFrom
            || this.props.yearTo !== nextProps.yearTo
            || this.props.monthTo !== nextProps.monthTo
            || this.props.charged !== nextProps.charged
            || this.props.histories !== nextProps.histories

            || this.state.success !== nextState.success
            || this.state.fail !== nextState.fail
            || this.state.usage !== nextState.usage
            || this.state.usageList !== nextState.usageList
            || this.state.account !== nextState.account
            || this.state.paymentInfo !== nextState.paymentInfo
            || this.state.checkItems !== nextState.checkItems

            || this.state.packageModal !== nextState.packageModal

        )
    }

    componentDidMount() {
        this.ajaxGetPaymentList();
    }

    /* setter */
    setLoading(loading) {
        this.setState({ loading: loading });
    }
    async setValue(id, value) {
        const { CashAction } = this.props;

        switch (id) {
            case "yearFrom" :
                await CashAction.setYearFrom(value);
                await CashAction.setPage(1);
                this.ajaxGetPaymentList();
                break;
            case "monthFrom":
                await CashAction.setMonthFrom(value);
                await CashAction.setPage(1);
                this.ajaxGetPaymentList();
                break;
            case "yearTo" :
                await CashAction.setYearTo(value);
                await CashAction.setPage(1);
                this.ajaxGetPaymentList();
                break;
            case "monthTo":
                await CashAction.setMonthTo(value);
                await CashAction.setPage(1);
                this.ajaxGetPaymentList();
                break;
            case "charged":
                await CashAction.setCharged(value);
                await CashAction.setPage(1);
                this.ajaxGetPaymentList();
                break;
            case "histories":
                break;
            default:
                break;
        }

    }

    /* 충전내역 상단 검색 조건 handlers */
    handleYearFromSelect = (e) => {
        const { CashAction } = this.props;
        CashAction.setYearFrom(Number(e.target.value));
        if(Number(e.target.value) === this.state.thisYearFrom-9){
            CashAction.setMonthFrom(this.state.thisMonthFrom);
        }
        this.setValue("yearFrom", Number(e.target.value));
    }
    handleMonthFromSelect = (e) => {
        const { CashAction } = this.props;
        CashAction.setMonthFrom(Number(e.target.value));
        this.setValue("monthFrom", Number(e.target.value));
    }
    handleYearToSelect = (e) => {
        const { CashAction } = this.props;
        CashAction.setYearTo(Number(e.target.value));
        if(Number(e.target.value) === this.state.thisYearTo-9){
            CashAction.setMonthTo(this.state.thisMonthTo);
        }
        this.setValue("yearTo", Number(e.target.value));
    }
    handleMonthToSelect = (e) => {
        const { CashAction } = this.props;
        CashAction.setMonthTo(Number(e.target.value));
        this.setValue("monthTo", Number(e.target.value));
    }
    onChangeCharged = (e) => {
        const { CashAction } = this.props;
        CashAction.setCharged(e.target.value);
        this.setValue("charged", e.target.value);
    }

    /* 모달 OPEN, CLOSE handlers */
    handlePaymentUsageModal() {
        const { usage } = this.state;
        this.setState({ usage: ! usage });
    }
    handlePackagePaymentUsageModal() {
        const { packageModal } = this.state;
        this.setState({ packageModal: ! packageModal });
    }
    handleAccountInfoUploadModal() {
        const { account } = this.state;
        this.setState({ account: ! account });
    }
    handleSuccessModal(bool) {
        this.setState({ success: bool });
        if(!bool) window.location.reload();
    }
    handleFailModal() {
        const { fail } = this.state;
        this.setState({ fail: ! fail });
    }

    /* handlers */
    async handleSearch() {
        const { CashAction } = this.props;
        const { ajaxGetPaymentList } = this;

        await CashAction.setPage(1);
        ajaxGetPaymentList();
    }
    async handlePageChange(event, value) {
        const { CashAction } = this.props;
        await CashAction.setPage(value);

        this.setState({ checkItems: [] });

        this.ajaxGetPaymentList();
    }
    handleSingleCheck(checked, uid) {
        if (checked) {
            this.setState({ checkItems: [...this.state.checkItems, uid] });
        } else {
            this.setState({ checkItems: this.state.checkItems.filter((item) => item !== uid) });
        }
    };
    handleAllCheck (checked) {
        const { histories } = this.props;

        if(checked) {
            const idArray = [];
            histories.forEach((item) => idArray.push(item.uid));
            this.setState({ checkItems: idArray })
        }
        else {
            this.setState({ checkItems: [] });
        }
    }

    /* ajax request methods */
    ajaxGetPaymentList = () => {
        const { page, size, charged, yearFrom, monthFrom, yearTo, monthTo } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/cash/payment/list",
            method: apiUtil.requestMethod.POST,
            data: {
                page: page,
                size: size,
                yearFrom: yearFrom,
                monthFrom: monthFrom,
                yearTo: yearTo,
                monthTo: monthTo,
                paymethod: charged
            },
            success: (result) => {
                const { CashAction } = this.props;
                CashAction.setHistories(result.content);
                CashAction.setTotal(result.total);
            }
        })
    }
    ajaxGetPaymentUsage(paymentInfo) {
        if(paymentInfo.packageId === null || paymentInfo.packageId === undefined) {
            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: `/api/cash/payment/${paymentInfo.uid}/history`,
                method: apiUtil.requestMethod.POST,
                success: (result) => {
                    this.setState({usageList: result});
                    this.handlePaymentUsageModal();
                }
            });
            this.setState({paymentInfo: paymentInfo});
        } else {
            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: `/api/cash/payment/${paymentInfo.uid}/history/package`,
                method: apiUtil.requestMethod.POST,
                success: (result) => {
                    this.setState({usageList: result});
                    this.handlePackagePaymentUsageModal();
                }
            });
            this.setState({paymentInfo: paymentInfo});
        }
    }
    ajaxDownloadExcel = () => {
        const { charged, yearFrom, monthFrom, yearTo, monthTo } = this.props;
        const { checkItems } = this.state;

        let data = {
            yearFrom: yearFrom,
            monthFrom: monthFrom,
            yearTo: yearTo,
            monthTo: monthTo,
            paymethod: charged,
            checkItems: checkItems
        }

        apiUtil.fileDownloadRequest({
            setLoading: this.setLoading,
            url: "/api/cash/payment/list/download",
            method: apiUtil.requestMethod.POST,
            data: data,
            success: (blob, filename) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
    }

    render() {
        const { loading } = this.state;

        const { yearFrom, monthFrom, yearTo, monthTo, charged, histories } = this.props;
        const { success, fail, usage, usageList, paymentInfo, account, checkItems, packageModal } = this.state;
        const { page, size, total } = this.props;

        const { handleYearFromSelect, handleMonthFromSelect, handleYearToSelect, handleMonthToSelect, onChangeCharged } = this
        const { handlePaymentUsageModal, handleAccountInfoUploadModal, handleSuccessModal, handleFailModal, handlePackagePaymentUsageModal } = this;
        const { handleSearch, handlePageChange, handleSingleCheck, handleAllCheck } = this;
        const { ajaxDownloadExcel, ajaxGetPaymentUsage } = this;

        return (
            <>
                <Loading loading={loading}/>
                <div className='container-xxl'>
                    <h2 className='fs-4'>충전 내역</h2>
                    
                    <div className='info-content-item shadow'>
                        <h5 className='d-flex align-items-center'>
                            <span className="material-symbols-outlined text-primary fs-4 pe-2 fw-bold">report</span>
                            <span>충전 내역</span>
                        </h5>
                        <ol className='fs-6 mb-0 fw-normal fs-4 ps-3 ps-sm-5 '>
                            <li>충전 / 사용 내역을 확인할 수 있습니다.</li>
                            <li>잔여금액 환불은 상세 버튼 내에서 신청 가능합니다.</li>
                            <li>환불은 결제 시 이용한 결제수단을 통해 진행될 예정입니다.</li>
                        </ol>
                    </div>
                    
                    <div className='card'>
                        <div className='card-body'>
                            {/* 화면 설계도 51페이지에 해당하는 충전 내역 확인 페이지*/}
                            {/*1번에 해당하는 결제 수단 구분 필터 + 9년까지의 조회와 내역 다운로드 버튼*/}
                            <div className='search-box bg-light p-lg-4 p-3'>
                                <div className='row pb-2 align-items-center'>
                                    <div className='col-lg-auto d-flex flex-sm-row flex-column  text-center'>
                                        <select className='form-select w-auto d-inline me-1' name="" id="" onChange={onChangeCharged} value={charged}>
                                            <option value="All">{paymethodMap['All']}</option>
                                            <option value="Card">{paymethodMap['Card']}</option>
                                            <option value="VBank">{paymethodMap['VBank']}</option>
                                            <option value="DirectBank">{paymethodMap['DirectBank']}</option>
                                        </select>
                                        {/*년 월 을 input으로 가지는 조회 필터 */}
                                        <YearMonthComp year={yearFrom} month={monthFrom} thisYear={this.state.thisYearFrom} thisMonth={this.state.thisMonthFrom} handleYearSelect={handleYearFromSelect} handleMonthSelect={handleMonthFromSelect}/>
                                        <span className='px-2'>~</span>
                                        <YearMonthComp year={yearTo} month={monthTo} thisYear={this.state.thisYearTo} thisMonth={this.state.thisMonthTo} handleYearSelect={handleYearToSelect} handleMonthSelect={handleMonthToSelect}/>
                                        <div className="d-inline-block w-auto mt-sm-0 mt-2 px-sm-2 px-0">
                                            <button className="btn btn-primary me-2" onClick={handleSearch}><div className='d-flex align-items-center'>조회 <span className="material-symbols-rounded fs-6 ms-1">search</span></div> </button>
                                            <button className='btn btn-success d-inline-flex align-items-center' onClick={ajaxDownloadExcel}>내역받기<span className="material-symbols-rounded fs-6">file_save</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='table-responsive mt-4'>
                                <table className="table table-full table-hover table-bordered">
                                    <thead className='table-light'>
                                    <tr>
                                        <th>
                                            <input
                                                className='form-check-input'
                                                type="checkbox"
                                                name="select-all"
                                                onChange={(e)=>handleAllCheck(e.target.checked)}
                                                checked={histories.length !== 0 && checkItems.length === histories.length}
                                            />
                                        </th>
                                        <th>결제 일시</th>
                                        <th>구분</th>
                                        <th>총 결제 금액</th>
                                        <th>결제 포인트</th>
                                        <th>잔여 포인트</th>
                                        <th>소진 여부</th>
                                        <th>결과</th>
                                        <th>환불 신청 상태</th>
                                        <th>비고</th>
                                        <th>플랜</th>
                                        <th>상세보기</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {histories.length === 0
                                            ? <tr><td colSpan={11} className="text-center">조건 설정 후 조회 버튼을 클릭해주세요.</td></tr>
                                            : histories.map((item, index) => (
                                                <tr key={index}>
                                                    <td className='text-center'>
                                                        <input
                                                            className='form-check-input'
                                                            type="checkbox"
                                                            name={`select-${item.uid}`}
                                                            onChange={(e) => handleSingleCheck(e.target.checked, item.uid)}
                                                            checked={checkItems.includes(item.uid)}
                                                        />
                                                    </td>
                                                    <td className='text-center'>{item.createdAt}</td>
                                                    <td className='text-center'>{item.paymethod}</td>
                                                    <td className='text-end'>{stringUtil.formatNumber(Math.floor(item.amount * 1.1))}원</td>
                                                    <td className='text-end'>{stringUtil.formatNumber(item.amount)} P</td>
                                                    <td className='text-end'>{stringUtil.formatNumber(item.balance)} P</td>
                                                    <td className='text-center'>{item.useStatus}</td>
                                                    <td className='text-center'>{item.paymentStatus}</td>
                                                    <td className='text-center'>{item.refundStatus}</td>
                                                    <td className='text-center'>{(item.paymentStatus === '입금대기' && item.paymethod === '무통장입금')
                                                        ? <span
                                                            dangerouslySetInnerHTML={{__html: item.description.split(",").join("<br>")}}></span>
                                                        : item.description}</td>
                                                    <td className='text-center'>{(item.packageId === null || item.packageId === undefined) ? '일반 요금제' : '패키지'}</td>
                                                    <td className='text-center'>
                                                        <button onClick={()=>ajaxGetPaymentUsage(item)}
                                                    className='btn btn-outline-primary btn-sm'>상세보기</button></td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent page={page} total={total} sizePerPage={size} handleChange={handlePageChange}/>

                            {/*환불 신청 완료 되었을때를 열리는 모달창*/}
                            <RefundSuccessModal
                                isOpen={success}
                                paymentInfo={paymentInfo}
                                handleClose={() => handleSuccessModal(false)}
                            />

                            {/*환불 신청 실패했을 때, 보여지는 모달창*/}
                            <RefundFailModal
                                isOpen={fail}
                                handleClose={handleFailModal}
                            />

                            {/*충전건별 이용 내역 모달창*/}
                            <PaymentUsageModal
                                isOpen={usage}
                                handleClose={handlePaymentUsageModal}
                                usageList={usageList}
                                paymentInfo={paymentInfo}
                                handleAccountInfoUploadModal={handleAccountInfoUploadModal}
                                handleSuccessModal={() => handleSuccessModal(true)}
                                handleFailModal={handleFailModal}
                            />

                            <PackagePaymentUsageModal
                                isOpen={packageModal}
                                handleClose={handlePackagePaymentUsageModal}
                                usageList={usageList}
                                paymentInfo={paymentInfo}
                                handleAccountInfoUploadModal={handleAccountInfoUploadModal}
                                handleSuccessModal={() => handleSuccessModal(true)}
                                handleFailModal={handleFailModal}
                            />

                            {/*무통장입금 환불 요청 시 통장사본 업로드 모달*/}
                            <AccountInfoUploadModal
                                isOpen={account}
                                handleClose={handleAccountInfoUploadModal}
                                paymentInfo={paymentInfo}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }//end render
}

export default connect(
    (state) => ({
        yearFrom: state.cashhistory.get("yearFrom"),
        monthFrom: state.cashhistory.get("monthFrom"),
        yearTo: state.cashhistory.get("yearTo"),
        monthTo: state.cashhistory.get("monthTo"),
        charged: state.cashhistory.get("charged"),
        success: state.cashhistory.get("success"),
        fail: state.cashhistory.get("fail"),
        histories: state.cashhistory.get("histories"),

        page: state.cashhistory.get('page'),
        size: state.cashhistory.get('size'),
        total: state.cashhistory.get('total'),
    }),
    (dispatch) => ({
        CashAction: bindActionCreators(cashAction, dispatch),
    })
)(CashChargedHistoryComp);
